import React, { ReactNode } from 'react';
import styles from './assets/screen.module.scss';
import classNames from 'classnames';
import ProviderReportsGrid from './components/ProviderReportsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IProviderReport } from '../../../../../types/providerReport';
import Loader from '../../../../../components/Loader';
import user from '../../../../../services/user-auth';
import UserRole from '../../../../../enumerables/user-role';
import { IServiceType } from '../../../../../types/service-types';
import { IServiceLocation } from '../../../../../types/service-locations';

export interface StateProps {
    data: Paginated<IProviderReport>;
    providers: SelectObject[];
    totals: any;
    inProgress: boolean;
    serviceTypes?: Paginated<IServiceType>;
    serviceLocations?: Paginated<IServiceLocation>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataTotal: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    clearTotal: () => void;
    getDataCsv: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class OccasionNoConsentList extends React.Component<Props, { isTotal: boolean; filters: any }> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isTotal: false,
            filters: {},
        };
        this.getData = this.getData.bind(this);
    }
    componentDidMount() {
        this.props.getProviders({
            page: 1,
        });
    }
    componentWillUnmount() {
        this.setState({ isTotal: false });
        this.props.clearTotal();
    }
    getTotals() {
        this.props.getDataTotal({ page: 1, filters: this.state.filters });
        this.setState({ isTotal: true });
    }
    getData(data: any) {
        if (data.filters) {
            this.setState({ ...this.state, filters: data.filters });
        }
        if (!this.state.isTotal) {
            data.notTotal = true;
        }
        this.props.getData({ ...data, page: data.page ? data.page : 1 });
    }

    public render(): ReactNode {
        const { getDataCsv, providers, inProgress, serviceTypes, serviceLocations } = this.props;
        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();

        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.pageHeadingTitle, 'pageHeadingTitle')}>
                        BILLING LOG {this.props.data.totalCount ? '(' + this.props.data.totalCount + ')' : ''}
                    </h2>

                    {!this.state.isTotal ? (
                        <button onClick={() => this.getTotals()} className={`btn btn-info`}>
                            Totals
                        </button>
                    ) : null}
                </div>
                <div className={classNames(styles.list)}>
                    {inProgress ? <Loader /> : null}
                    {/*<div className={classNames(styles.responsive)}>
                        <div className={classNames(styles.totalItems)}>
                            {this.state.isTotal &&
                                this.props.totals.map((it: string, k) => {
                                    if (typeof it === 'string') {
                                        return (
                                            <div className={classNames(styles.totalItem)} key={k}>
                                                <b style={{ fontSize: '0.75rem' }}>Total:</b> {it}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                        </div>
                    </div>*/}

                    <ProviderReportsGrid
                        serviceTypes={serviceTypes}
                        serviceLocations={serviceLocations}
                        providers={providers}
                        getDataCsv={getDataCsv}
                        data={this.props.data}
                        getData={this.getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default OccasionNoConsentList;
